
export class RetencionDetalle {
    id: number;
    idRetencion: number;
    orden:number
    numeroRetencion: string;
    fechaEmision: Date;
    codigo: string;
    codigoImpuesto:string;
    descripcion: string;
    base:number;
    porcentaje:number;
    total:number;
    }

    